import React, { useEffect } from "react";

// components
import {
  Card,  
  Container,
  Row,
  Col,
  CardBody,
  Spinner
} from "reactstrap";
import { Map, TileLayer, Marker, GeoJSON } from 'react-leaflet'
import L from 'leaflet'
import queryString from 'query-string';
 
// style
import "../../../assets/css/loading.css";
import "../../../assets/css/map.css";
import "../../../assets/css/mapMonitoramentoTV.css";

// services
import { showMessage } from "../../../services/message.js";
import {  api_GET, api_POST } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

// helpers
import useInterval from "helpers/useInterval.js";

export default function MonitoramentoTV({history}) {
    const session = getSessionCookie();      

    const [showLoading, setshowLoading] = React.useState(false);    

    const [centerMap, setcenterMap] = React.useState([-3.7281458,-38.5762694]); 
     
    const [viewPontos, setviewPontos] = React.useState(false);    
    const [viewAlertas, setviewAlertas] = React.useState(true);

    const [regional, setRegional] = React.useState([]);
    const [regionalJson, setregionalJson] = React.useState(null);
    const [territorioJson, setterritorioJson] = React.useState(null);    
    const [delimitacao, setdelimitacao] = React.useState("")
    const handleDelimitacao = (value) => {
        setdelimitacao(value);
        if (value == "Regional" && regionalJson == null){
            if (localStorage.getItem("regionais") != null)
            {
                setregionalJson(JSON.parse(localStorage.getItem("regionais")));
            }
            else
            {
                setshowLoading(true);
                api_GET('regional/GetWithGeoJson').then(result => {          
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else{
                        localStorage.setItem("regionais", JSON.stringify(result.data));
                        setregionalJson(result.data);            
                    }
                });
            }
        }
        else if (value == "Território" && territorioJson == null){
            if (localStorage.getItem("territorios") != null)
            {
                setterritorioJson(JSON.parse(localStorage.getItem("territorios")));
            }
            else
            {
                setshowLoading(true);
                api_GET('territorio/GetWithGeoJson').then(result => {          
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else{
                        localStorage.setItem("territorios", JSON.stringify(result.data));
                        setterritorioJson(result.data);            
                    }
                });
            }
        }
    }

    const [monitoramento, setMonitoramento] = React.useState(null);
    const GetMonitoramento = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        let regionais = [];
        if (params.regionais != null && params.regionais != ""){
            let _reg = params.regionais.split('-');
            for(var i in _reg){
                if (_reg[i] != "" && _reg[i] != "-")
                    regionais.push(_reg[i].replace("-", ""));
            }
        }

        let json_post = {
            concessionariaId: session.concessionariaId,
            modalidadeColetaId: params.modalidadeColetaId,
            setorColetaId: params.setorColetaId,
            veiculoId: params.veiculoId,
            regionalId: regionais
        }         

        if (params.viewPontos == "true")
            setviewPontos(true);
        if (params.viewAlertas == "true")
            setviewAlertas(true);
        
        setRegional(regionais);
    
        setshowLoading(true);

        if (params.delimitacao != null){
            handleDelimitacao(params.delimitacao);
        }
        
        api_POST('monitoramento/filtro', json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else{
                setMonitoramento(result.data);                
            }            
        });
    }

    const handleIconInconformidade = () => {
        return new L.Icon({
                        iconUrl: require('assets/img/icons/alerta-amarelo.png'),
                        iconSize: [28,33],
                        iconRetinaUrl: require('assets/img/icons/alerta-amarelo.png')
                    });
    }    

    const handleIconColeta = (item) => {
        let icon = "";
        if (item.statusColeta == "Programada")
            icon = "veiculo-azul"
        else if (item.statusColeta == "Execução Iniciada")
            icon = "veiculo-roxo"
        else if (item.statusColeta == "Execução Parcial")
            icon = "veiculo-amarelo"
        else if (item.statusColeta == "Execução Total")
            icon = "veiculo-verde"
        else if (item.statusColeta == "Não Execução")
            icon = "veiculo-vermelho"
       return new L.Icon({
                        iconUrl: require('assets/img/icons/' + icon + '.png'),                        
                        iconRetinaUrl: require('assets/img/icons/' + icon + '.png'),        
                    }); 
    }

    useEffect(() => {               
        GetMonitoramento();        
    }, []);

    useInterval(GetMonitoramento, 120000);        

    return (
    <>           
    {showLoading && 
          <div className="carregandoCmp">
              <div className="box">
                <label style={{marginRight:"20px"}}>Carregando...</label>
                <Spinner size="sm" color="info" />
              </div>
          </div> 
        }     
        <div>        
            <Container className="mt-2" fluid>
                <Card className="shadow">                    
                    <CardBody>                                                                                                             
                            <Row>                                
                                <Col md="12">
                                    <div id="mapa-tv">
                                        <Map center={centerMap} zoom={12} style={{zIndex:"0"}}>
                                        <TileLayer
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        />  
                                            {(viewAlertas && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.map((m) => {
                                                return m.monitoramentoOrdemColetaInconformidades.map(i => {                                                    
                                                            return <Marker key={i.ordemColetaInconformidadeId} position={[i.latitude, i.longitude]} icon={handleIconInconformidade()} >
                                                                    </Marker>
                                                        })
                                            })}

                                            {(viewPontos && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.filter(f => f.latitudeVeiculo != null && f.latitudeVeiculo != "").map((m) => {
                                                return m.monitoramentoPontoColetas.map((i) => {                                                    
                                                            return <Marker key={i.ordemColetaPontoColetaId} position={[i.latitude, i.longitude]} icon={handleIconColeta(i)}>
                                                                    </Marker>
                                                })
                                            })}

                                            {
                                                delimitacao == "Regional" && regionalJson != null && regionalJson.filter(f => regional.length == 0 || regional.filter(r => r == f.regionalId).length > 0)
                                                .map(item => (                                                    
                                                    <GeoJSON key={item.regionalIdId} data={JSON.parse(item.geoJson)}></GeoJSON>
                                                ))
                                            }

                                            {
                                                delimitacao == "Território" && territorioJson != null && territorioJson.filter(f => regional.length == 0 || regional.filter(r => r == f.regionalId).length > 0)
                                                .map(item => (                                                    
                                                    <GeoJSON key={item.territorioId} data={JSON.parse(item.geoJson)}></GeoJSON>
                                                ))
                                            }
           
                                        </Map>
                                    </div>
                                </Col>
                            </Row>                              
                            
                    </CardBody>
                </Card>
            </Container>                    
        </div>                
        
    </>
    );
}
